import React, { PropTypes, Component } from 'react'
import styles from '../styles'
import CellDiv from './cellDiv'
import misc from 'utils/misc'

export default class DateInputCell extends Component {
  static propTypes = {
    dataKey: PropTypes.string.isRequired,
    width: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  constructor (props) {
    super(props)
    this.onChange = (e) => {
      console.log(e.target.value)
      this.setState({ value: e.target.value })
      if (misc.isValidDateString(e.target.value)) {
        this.props.onChange(props.dataKey, e.target.value)
      }
    }
    this.onBlur = (e) => {
      if (!misc.isValidDateString(e.target.value)) {
        this.setState({ value: '' })
      }
    }
  }

  state = {
    value: this.props.value,
  };

  componentWillReceiveProps (nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: nextProps.value })
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    // you need to avoid update by passing same items object to it
    const compareKeys = ['value', 'width']
    return !misc.isObjectEqual(this.props, nextProps, compareKeys) ||
           !misc.isObjectEqual(this.state, nextState)
  }

  render () {
    return (
      <CellDiv width={this.props.width} className={styles.dateInputCell}>
        <input
          placeholder="xxxx-xx-xx"
          value={this.state.value}
          onChange={this.onChange}
          onBlur={this.onBlur}
        />
      </CellDiv>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataTable/dataCell/dateInputCell.jsx